import { Directive, EventEmitter, Output } from '@angular/core';
import { FI_SWIPE_DIRECTION, FiSwipeBase } from './fi-swipe-base';

@Directive({
    selector: '[fiSwipeLeft]',
    standalone: false,
})
export class FiSwipeLeftDirective extends FiSwipeBase {
    @Output() fiSwipeLeft = new EventEmitter();

    protected _swipeEndCheck() {
        if (this.swipeDirection !== FI_SWIPE_DIRECTION.Horizontal) {
            return;
        }

        const deltaX = this.touchStartEvent.touches[0].screenX - this.lastTouchEvent.touches[0].screenX,
            deltaY = Math.abs(this.lastTouchEvent.touches[0].screenY - this.touchStartEvent.touches[0].screenY);
        if (deltaX > this.threshold && deltaX > deltaY) {
            this.fiSwipeLeft.emit();
        }
    }
}
